<template>
  <div>
    <TableFilters
      :filters="['product', 'warehouse', 'dateRange']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`purchasereturnexport`]"
    ></TableFilters>

    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2 pa-3" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="PurchaseReturnList"
              class="row-pointer"
              id="indextable9"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Purchase" />
                </div>
              </template>

              <template v-slot:top>
                <tr>
                  <th>Product Name:</th>
                  <th>{{ filterDatas.productquery }}</th>
                  <th></th>
                  <th>Warehouse Name:</th>
                  <th>{{ filterDatas.warehousequery }}</th>
                </tr>
              </template>

              <template v-slot:item.date="{ item }">{{
                item.date | formatDate
              }}</template>
              <template v-slot:item.quantity="{ item }">{{
                item.quantity ? item.quantity : '.......'
              }}</template>

              <template v-slot:item.total="{ item }">{{
                item.purchaseReturn.sub_total_amount
                  ? item.purchaseReturn.sub_total_amount
                  : '.......'
              }}</template>

              <template v-slot:item.reason="{ item }">{{
                item.purchaseReturn.reason
                  ? item.purchaseReturn.reason
                  : '.......'
              }}</template>

              <template v-slot:item.status="{ item }">{{
                item.purchaseReturn.status
                  ? item.purchaseReturn.status
                  : '.......'
              }}</template>

              <template v-slot:item.supplier="{ item }">{{
                item.purchaseReturn.supplier.name
                  ? item.purchaseReturn.supplier.name
                  : '.......'
              }}</template>

              <template v-slot:item.wareHouse="{ item }">{{
                item.purchaseReturn.wareHouse.name
                  ? item.purchaseReturn.wareHouse.name
                  : '.......'
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import noData from '@/components/shared/noItem';
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';
export default {
  data: () => ({
    messages: [],
    hide: '',
    errors: [],
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Number',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },

      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => moment(item.purchaseReturn.date).format('YYYY-MM-DD'),
      },

      {
        text: 'Quantity',
        value: 'quantity',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.quantity,
      },

      {
        text: 'Total Amount',
        value: 'total',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.purchaseReturn.sub_total_amount,
      },

      {
        text: 'Return Reason',
        value: 'reason',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) =>
          item.purchaseReturn.reason
            ? item.purchaseReturn.reason
            : '..........',
      },

      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.purchaseReturn.status,
      },

      {
        text: 'Supplier',
        value: 'supplier',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchaseReturn.supplier.name,
      },

      {
        text: 'WareHouse',
        value: 'wareHouse',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchaseReturn.wareHouse.name,
      },
    ],
    PurchaseReturnList: [],
    date_range: [],
    filter: {
      invoice_status: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
    },
    menu: false,
  }),
  components: {
    TableFilters,
    noData,
  },
  computed: {
    ...mapState(['filterDatas']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      if (this.filter.warehouse && this.filter.product) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        var filter = this.filter;
        this.$store
          .dispatch('report/getPurchaseReturnReportProductManagement', filter)

          .then((res) => {
            if (res.data.data.length === 0) {
              this.PurchaseReturnList = [];
            } else {
              this.PurchaseReturnList = res.data.data[0].purchaseReturnItems;
              let i = 1;
              this.PurchaseReturnList.map((p) => {
                p.no = i;
                i++;
              });
            }

            setTimeout(() => {
              callBack();
              // Update Pdf To List
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.PurchaseReturnList);
              // Update Pdf To List_Title
              this.$store.commit(
                'UPDATE_PDF_TITLE',
                'Purchase Return Report Product Management',
              );
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            }, 300);
          })

          .catch((err) => {
            this.isLoading = false;
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDF_VISIBLE', false);
            this.messages = err.data.title;
          });
      } else if (this.filter.warehouse) {
        this.$confirm('Please Select the Product then Try?');
      } else if (this.filter.product) {
        this.$confirm('Please Select the Warehouse then Try?');
      } else {
        this.$confirm('Please Select the Warehouse and Product then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.PurchaseReturnList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },
    //Product Details Export Pdf
    async exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.PurchaseReturnList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
          Data[x].quantity = Data[x].quantity;
          Data[x].total = Data[x].purchaseReturn.sub_total_amount;
          Data[x].reason = Data[x].purchaseReturn.reason
            ? Data[x].purchaseReturn.reason
            : '........';
          Data[x].status = Data[x].purchaseReturn.status;
          Data[x].supplier = Data[x].purchaseReturn.supplier.name;
          Data[x].wareHouse = Data[x].purchaseReturn.wareHouse.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Purchase Return Report Product Management', 14, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        const conditions = [
          { key: 'productquery', label: 'Product' },
          { key: 'warehousequery', label: 'Warehouse' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }

          return acc;
        }, 12); // Initial

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(
          `${moment(today).format('DD-MM-YYYY')}-Purchase Return Report.pdf`,
        );
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable9');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Purchase Return Report.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
    getStatusColor(is_active) {
      return is_active ? 'green' : 'gray';
    },

    dateFormat: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>
